import React from 'react';
import {
  Navigate,
} from 'react-router-dom';
import PropTypes from 'prop-types';

const PrivateRoute = ({
  children,
}) => {
  const userID = localStorage.getItem('id');

  if (!userID) return <Navigate to="/metior/login" replace />;

  if (children) return children;

  return <p style={{ margin: '30px', textAlign: 'center' }}>Loading...</p>;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
